import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LoadingText = styled.p`
  font-size: 14px;
  letter-spacing: 0.25em;
  line-height: 1.7em;
  margin: 15px 0;
  max-width: 280px;
`;

export const SubmitContainer = styled("div")`
  margin: 10px 0;
`;

export const ErrorContainer = styled("div")`
  margin: 10px 0;
`;

export const InfoText = styled.p`
  font-size: 14px;
  color: #ff0000;
  letter-spacing: 0.025em;
  line-height: 1.65em;
  margin: 25px auto 10px auto;
`;

export const GoTopButton = styled.button`
  background-color: #10459b;
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  border: 1px solid #10459b;
  border-radius: 8px;
  padding: 12px 24px;
  margin: 10px 16px 16px 16px;
  cursor: pointer;
  min-height: 32px;
`;
